import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserWithRolesResponse } from '../inspection-companies/models/users/user-with-roles.response';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../models/paginated.response';
import { toHttpParams } from 'projects/shared/utils/httpParamsHelpers';
import { GetUsersForInspectionCompanyModel } from '../inspection-companies/models/users/get-users-for-inspection-company.request';
import { DeleteUsersRequest, InviteUsersRequest, UpdateUserRequest } from '../inspection-companies/inspection-company.user.service';
import { UsersDeletedResponse } from '../inspection-companies/models/users/users-deleted-response';
import { ReinvitePendingUsersModel } from '../invitations/models/reinvite-pending-users.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  baseUrl: string;

  constructor(private httpClient: HttpClient) {
    this.baseUrl = `${environment.restApiBaseUrl}/api/users`;
  }

  getUsers(filterCriteria: GetUsersForInspectionCompanyModel): Observable<PaginatedResponse<UserWithRolesResponse>> {
    const params = toHttpParams(Object.entries(filterCriteria));
    const url = `${this.baseUrl}/admin`;
    return this.httpClient.get<PaginatedResponse<UserWithRolesResponse>>(url, { params });
  }

  inviteUsers(users: InviteUsersRequest[]): Observable<UserWithRolesResponse[]> {
    const url = `${this.baseUrl}`;
    return this.httpClient.post<UserWithRolesResponse[]>(url, { users });
  }

  updateUser(userId: number, model: UpdateUserRequest): Observable<void> {
    const url = `${this.baseUrl}/admin/${userId}`;
    return this.httpClient.put<void>(url, model);
  }

  deleteUsers(request: DeleteUsersRequest): Observable<UsersDeletedResponse> {
    const options = { body: request };
    const url = `${this.baseUrl}/admin`;
    return this.httpClient.delete<UsersDeletedResponse>(url, options);
  }

  reinvitePendingUsers(model: ReinvitePendingUsersModel): Observable<void> {
    const url = `${this.baseUrl}/admin/reinvite`;
    return this.httpClient.post<void>(url, model);
  }
}